import { omit } from 'lodash'

import CowmedChip, { CowmedChipProps } from '#/components/Chip'
import {
  PageBuilderIcon,
  PageBuilderIconProps,
} from '#/store/providers/Pagebuilder/Components/Icon'

type PageBuilderChipProps = {
  value: CowmedChipProps['value']
  level?: CowmedChipProps['level']
  variant?: CowmedChipProps['variant']
  prefix?: PageBuilderIconProps
}

export const PageBuilderChip = ({ level, prefix, value, variant }: PageBuilderChipProps) => {
  return (
    <CowmedChip
      value={value}
      level={level}
      variant={variant}
      width="unset"
      icon={<PageBuilderIcon {...omit(prefix, 'level')} />}
      sx={{
        '& .MuiChip-label': {
          px: 1,
        },
        'paddingLeft': 0.5,
      }}
    />
  )
}
